import { useContext, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { ProfileUI } from './ui'
import { IProfileUI } from './types'

import { useProfile } from '@api/profile/state'
import { useInput } from '@hooks/useInput'
import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'
import { reportUnexpectedClientError } from '@services/client-error.service'

/** Контейнер UI - Мой профиль */
export const ProfileContainer = () => {
    const notify = useContext(NotificationContext)

    const txtCurrentPassword = useInput<string>('')
    const txtNewPassword = useInput<string>('')
    const txtConfirmPassword = useInput<string>('')

    const {
        isLoadingProfile,
        isLoadingPassword,
        profile,
        clearStateProfile,
        actionGetProfile,
        actionChangePassword,
    } = useProfile(useShallow((state) => ({
        isLoadingProfile: state.isLoadingProfile,
        isLoadingPassword: state.isLoadingPassword,
        profile: state.profile,
        clearStateProfile: state.clearStateProfile,
        actionGetProfile: state.actionGetProfile,
        actionChangePassword: state.actionChangePassword,
    })))

    const handleLoadProfile = () => {
        actionGetProfile().then((res) => {
            if (res.status !== 200) notify && notifyOpen(res.message, 'error', 2000, notify)
        }).catch((res) => {
            reportUnexpectedClientError(res, 'Profile.actionGetProfile')
            notify && notifyOpen(res.message, 'error', 2000, notify)
        })
    }

    const clearPasswordForm = () => {
        txtCurrentPassword.setValue('')
        txtNewPassword.setValue('')
        txtConfirmPassword.setValue('')
    }

    const handleChangePassword = () => {
        if (!txtCurrentPassword.value) return notify && notifyOpen('Укажите текущий пароль.', 'warning', 2000, notify)
        if (txtNewPassword.value.length < 8) return notify && notifyOpen('Новый пароль должен быть не менее 8 символов.', 'warning', 2000, notify)
        if (txtNewPassword.value !== txtConfirmPassword.value) return notify && notifyOpen('Новый пароль и повтор пароля не совпадают.', 'warning', 2000, notify)

        actionChangePassword({
            currentPassword: txtCurrentPassword.value,
            newPassword: txtNewPassword.value,
            confirmPassword: txtConfirmPassword.value,
        }).then((res) => {
            if (res.status === 200) {
                clearPasswordForm()
                notify && notifyOpen('Пароль успешно изменён', 'success', 2000, notify)
            } else {
                notify && notifyOpen(res.message, 'error', 2000, notify)
            }
        }).catch((res) => {
            reportUnexpectedClientError(res, 'Profile.actionChangePassword')
            notify && notifyOpen(res.message, 'error', 2000, notify)
        })
    }

    useEffect(() => {
        handleLoadProfile()

        return () => {
            clearStateProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const propsToUI: IProfileUI = {
        isLoadingProfile,
        isLoadingPassword,
        profile,
        profileSites: profile.itemsSites,
        profileAccess: profile.itemsAccess,
        txtCurrentPassword,
        txtNewPassword,
        txtConfirmPassword,
        handleLoadProfile,
        handleChangePassword,
    }

    return <ProfileUI {...propsToUI} />
}